module.exports = __webpack_public_path__ + "static/img/img-features-feature-2-game-6@2x.4c9ef2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/img-features-feature-2-game-6@2x.png
// module id = iCGb
// module chunks = 18